/**
 * Emap 的校验字段匹配到 data-form 规则名称
 */
export const regRuleMap = {
  'custom[email]': 'email',
  'custom[phone]': 'mobile',
  'custom[tel]': 'tel',
  'custom[chinaZip]': 'zip',
  'custom[chinaIdLoose]': 'idcard',
  'custom[number]': 'number',
  'custom[chinese]': 'chinese',
  'custom[integer+]': 'positive',
  'custom[integer+0]': 'natural',
  'custom[money]': 'money',
  'custom[score]': 'score' // 这个正则暂时不明确用途，跟之前一样只校验正整数

};